import FeriaCultural from './FeriaCultural';

export default FeriaCultural;